import Vue from 'vue'
import Vuetify from 'vuetify'
import DatetimePicker from 'vuetify-datetime-picker'
import { VEmojiPicker } from 'v-emoji-picker'
import moment from 'moment'
import VueTheMask from 'vue-the-mask'
import axiosHelper from './mixins/axios-helper'
import store from './store'
import router from './router'
import App from './App.vue'

Vue.use(VEmojiPicker)
Vue.use(VueTheMask)
const EventBus = window.EventBus = new Vue()
const files = require.context('./components/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop()
  .split('.')[0], files(key).default))

Vue.use(Vuetify, {
  iconfont: 'fa', // 'md' || 'mdi' || 'fa' || 'fa4
  theme: {
    primary: '#424242',
    secondary: '#FF8F00',
    accent: '#FF8F00'
  }
})
Vue.mixin(axiosHelper)
Vue.use(DatetimePicker)

Vue.config.productionTip = false
Vue.prototype.$moment = moment


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
